import styled from 'styled-components';

interface MainContainerProps {
  $backgroundColor?: string; 
}

const MainContainer = styled.div<MainContainerProps>`

  background-color: ${props => props.$backgroundColor || '#ffffff'};
  max-width: 480px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (orientation: landscape) and (max-width: 960px) {
    width: 100%;
    max-width: 100%;
    height: 100%;
  }

  @media screen and (min-width: 768px) {
    width: 100%;
    max-width: 100%;
  }
`
  
export default MainContainer;